export default __webpack_public_path__ + "static/media/usdp.42531970.svg";